import { render, staticRenderFns } from "./terra-form.component.vue?vue&type=template&id=e7b87d46&scoped=true"
import script from "./terra-form.component.vue?vue&type=script&lang=js"
export * from "./terra-form.component.vue?vue&type=script&lang=js"
import style0 from "./terra-form.component.vue?vue&type=style&index=0&id=e7b87d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b87d46",
  null
  
)

export default component.exports